import { Component, OnInit, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { AuxiliaresModule } from '../../../../auxiliares/auxiliares.module';
import { IExcepcion } from 'modelos/src';
import { ExcepcionsService } from '../../../../auxiliares/servicios/http/excepcions.service';
import { DateRangePickerComponent } from '../../../../componentes/date-range-picker/date-range-picker.component';

@Component({
  selector: 'app-excepcion',
  templateUrl: './crear-excepcion.component.html',
  styleUrls: ['./crear-excepcion.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    AuxiliaresModule,
    DragDropModule,
    DateRangePickerComponent,
  ],
})
export class CrearExcepcionComponent implements OnInit {
  private fb = inject(FormBuilder);
  private service = inject(ExcepcionsService);
  dialogRef = inject<MatDialogRef<CrearExcepcionComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  form: FormGroup;
  readonly maxFechaExcepcion = new Date('2099-12-31');

  // Flags para saber si mostrar selectores
  mostrarSelectorEntidad: boolean;
  mostrarSelectorTipoEntidad: boolean;
  mostrarSelectorTipoExcepcion: boolean;

  // Datos para los selectores (por ahora vacíos, los llenas después)
  entidades: any[] = [];
  tiposEntidad: any[] = [];
  tiposExcepcion: any[] = [];

  constructor() {
    const data = this.data;

    // Determinar qué selectores mostrar
    this.mostrarSelectorEntidad = !data?.idEntidad && !data?.soloLocal;
    this.mostrarSelectorTipoEntidad = !data?.tipoEntidad;
    this.mostrarSelectorTipoExcepcion = !data?.tipoExcepcion;

    // Crear el formulario con todos los campos
    this.form = this.fb.group({
      idEntidad: [
        data?.idEntidad || null,
        data?.soloLocal ? [] : Validators.required,
      ],
      tipoEntidad: [data?.tipoEntidad || null, Validators.required],
      tipoExcepcion: [data?.tipoExcepcion || null, Validators.required],
      range: [
        data?.fechaDesde && data?.fechaHasta
          ? { start: data.fechaDesde, end: data.fechaHasta }
          : null,
        Validators.required,
      ],
    });
  }

  ngOnInit(): void {}

  onCancelar(): void {
    this.dialogRef.close();
  }

  async onGuardar(): Promise<void> {
    if (this.form.valid) {
      const excepcion: any = {
        idEntidad: this.form.value.idEntidad,
        tipoEntidad: this.form.value.tipoEntidad,
        tipoExcepcion: this.form.value.tipoExcepcion,
        fechaDesde: this.form.value.range.start,
        fechaHasta: this.form.value.range.end,
      };

      if (this.data?.soloLocal) {
        this.dialogRef.close(excepcion);
        return;
      }

      try {
        if (this.data._id) {
          // Si tiene _id, es una actualización
          const excepcionActualizada = await this.service.update(
            this.data._id,
            excepcion,
          );
          this.dialogRef.close(excepcionActualizada);
        } else {
          // Si no tiene _id, es una creación
          const excepcionCreada = await this.service.create(excepcion);
          this.dialogRef.close(excepcionCreada);
        }
      } catch (error) {
        console.error('Error al guardar la excepción:', error);
      }
    }
  }
}
